
import * as React from "react";
import {useState} from "react";
import jfetch from "../../utils/jfetch";
import Modal from "../core/Modal";
import gravatar from "gravatar";
import { toast } from "../../utils";

const BuildChat = (props, image) =>{
  let object = '{"username":"'+props.rawUserContext.user.data.attributes.email+'", "name":"'+props.rawUserContext.user.data.attributes.name+'", "room" : "'+props.id+'", "image":"'+image+'", "admin":"'+(props.rawUserContext.organization.data.id == props.room.owner ? true : props.rawUserContext.user.data.attributes.isAdmin )+'", "bot_name":"'+(props.room?.name || '')+'", "bot_image":"'+props.logo+'", "user_company":"'+(props.rawUserContext.organization.data.attributes.name || '')+'", "user_title":"'+(props.rawUserContext.user.data.attributes.jobTitle || '')+'"}';
  let url = 'https://chat.chartec.net/index.html?object='+encodeURI(btoa(object));
  return url;
}

const BuildInfo = (props, image) =>{
  let object = '{"username":"'+props.rawUserContext.user.data.attributes.email+'", "name":"'+props.rawUserContext.user.data.attributes.name+'", "room" : "'+props.id+'", "image":"'+image+'", "admin":"'+props.rawUserContext.user.data.attributes.isAdmin+'", "user_company":"'+(props.rawUserContext.organization.data.attributes.name || '')+'", "user_title":"'+(props.rawUserContext.user.data.attributes.jobTitle || '')+'"}';
  let url = 'https://chat.chartec.net/info.html?object='+encodeURI(btoa(object));
  return url;
}

const BuildAnalytics = (props, day) =>{
  var email = props.rawUserContext.user.data.attributes.email;
  var email_string_array = email.split("@");
  var domain_string_location = email_string_array.length -1;
  var final_domain = email_string_array[domain_string_location];
  let logo = props.logo || '';
  let title = props.id.charAt(0).toUpperCase() + props.id.slice(1);
  let object = '{"day":"'+day.value+'","page":"'+window.location.pathname+'","title":"'+title+'","logo":"'+logo+'","remove":"'+final_domain+'"}';
  let url = 'https://matomo.chartec.net/sponsor_reports/dynamic.php?object='+encodeURI(btoa(object));
  window.open(url,'_blank');
}

function SponsorRoom(props){
  const title = props.id.charAt(0).toUpperCase() + props.id.slice(1);
  document.title = "CORE | Sponsor | "+title
  const is_admin = props.rawUserContext.user.data.attributes.roles.includes("company_admin");
  const current_user_email = props.rawUserContext.user.data.attributes.email;
  const room = props.room;
  const [company_name, set_company_name] = useState(props.room?.name || '');
  const banners = {background: props.background, left_ad: props.leftAd, right_ad: props.rightAd, top_ad: props.topAd, bottom_ad: props.bottomAd};
  const [edit, set_edit] = useState(false);
  const [log_open, set_log_open] = useState(false);
  const [analytics_open, set_analytics_open] = useState(false);
  const [error, set_error] = useState(false);
  const [background, set_background] = useState();
  const [open, set_open] = useState(props.room?.open != null ? props.room?.open : false);
  const [left_ad, set_left_ad] = useState();
  const [right_ad, set_right_ad] = useState();
  const [top_ad, set_top_ad] = useState();
  const [bottom_ad, set_bottom_ad] = useState();
  const [email, set_email] = useState(props.room?.email || '');
  const [left_ad_link, set_left_ad_link] = useState(props.room?.left_ad_link || '');
  const [right_ad_link, set_right_ad_link] = useState(props.room?.right_ad_link || '');
  const [top_ad_link, set_top_ad_link] = useState(props.room?.top_ad_link || '');
  const [bottom_ad_link, set_bottom_ad_link] = useState(props.room?.bottom_ad_link || '');
  const [company_owner, set_company_owner] = useState(props.room?.owner || '');
  const [logo, set_logo] = useState(props.room?.logo || '');
  const [background_enabled, set_background_enabled] = useState(props.room?.background_enabled != null ? props.room?.background_enabled : true);
  const [top_ad_enabled, set_top_ad_enabled] = useState(props.room?.top_ad_enabled != null ? props.room?.top_ad_enabled : true);
  const [bottom_ad_enabled, set_bottom_ad_enabled] = useState(props.room?.bottom_ad_enabled != null ? props.room?.bottom_ad_enabled : true);
  const [left_ad_enabled, set_left_ad_enabled] = useState(props.room?.left_ad_enabled != null ? props.room?.left_ad_enabled : true);
  const [right_ad_enabled, set_right_ad_enabled] = useState(props.room?.right_ad_enabled != null ? props.room?.right_ad_enabled : true);
  const [historical_chat, set_historical_chat] = useState();
  var stream_url = localStorage.getItem('stream_url');
  var stream_page = localStorage.getItem('stream_page');

  if(room && Object.keys(room).length){
    return (
      <div style={background_enabled == true ? {background : "url("+banners.background+")", backgroundRepeat: "no-repeat",backgroundSize: "cover"} : {}}>
        <div className="stuck"><a href={stream_page || "/live/1"} style={{marginTop: "-40px",float: "right"}}className="btn btn-primary">Go To Stream Page</a><iframe style={{float : "right"}} src={stream_url} frameBorder="0" allow="autoplay; fullscreen"></iframe></div>
        {is_admin || (props.rawUserContext.organization.data.id == room.owner) ? <div className="row" style={{paddingTop : "15px"}}><div style={{marginLeft : "50px"}} className="btn btn-primary" onClick={()=>{set_edit(true)}}>Edit Booth</div><div style={{marginLeft : "10px"}} className="btn btn-primary" onClick={()=>{toggle_booth(props, open)}}>{open ? "Close Booth" : "Open Booth"}</div><div style={{marginLeft : "10px"}} className="btn btn-primary" onClick={()=>{open_info(BuildInfo(props, gravatar.url(props.rawUserContext.user.data.attributes.email, { s: 95, d: "identicon" })))}}>Info</div><div style={{marginLeft : "10px"}} className="btn btn-primary" onClick={()=>{set_log_open(true)}}>Chat Log</div><a style={{marginLeft : "10px"}} className="btn btn-primary" onClick={()=>{set_analytics_open(true)}}>Analytics</a></div>:''}
        <div className="row" style={{paddingTop : "15px"}}>
          <div className="col-xs-1"></div>
          <div className="fiftypx-left fiftypx-right col-xs-10 col-md-9"><a rel="noopener noreferrer" target="_blank" href={top_ad_link || "#"}>{top_ad_enabled == true ? <img width="100%" src={banners.top_ad} /> : ""}</a></div>
        </div>
        <div className="row" style={{paddingTop : "15px"}}>
          <div className="col-md-1 hidden-sm hidden-xs"></div>
            <div className="col-md-2 fiftypx-left hidden-sm hidden-xs">
              <a rel="noopener noreferrer" target="_blank" href={left_ad_link || "#"}>{left_ad_enabled == true ? <img width="100%" src={banners.left_ad} /> : ""}</a>
            </div>
            <div className="col-sm-12 col-md-5">
            {open ? <div style={{padding:"225px 0 ", width:"100%", height:"100%", position:"relative"}}><iframe scrolling="no" src={BuildChat(props, gravatar.url(props.rawUserContext.user.data.attributes.email, { s: 95, d: "identicon" }))} style={{position: "absolute",top:0,left:0,width:"100%",height:"100%"}} frameBorder="0"></iframe></div> : <div style={{padding:"225px 0 ", width:"100%", height:"100%", position:"relative", background: 'white'}}><div className="closed-message"><img className="center-image" src={props.logo} /><h3 className="center-text">We'll Be Back.</h3><p className="center-text">Our booth is not currently open. Thanks for stopping by!</p></div></div>}
            </div>
            <div className="col-xs-2 fiftypx-right hidden-sm hidden-xs">
              <a rel="noopener noreferrer" target="_blank" href={right_ad_link || "#"}>{right_ad_enabled == true ? <img width="100%" src={banners.right_ad} /> : ""}</a>
            </div>
            <div className="col-xs-1 hidden-sm hidden-xs"></div>
        </div>
        <div className="row" style={{paddingTop : "15px"}}>
          <div className="col-xs-1"></div>
          <div style={{marginBottom: "30px"}}className="fiftypx-left fiftypx-right col-xs-10 col-md-9"><a rel="noopener noreferrer" target="_blank" href={bottom_ad_link || "#"}>{bottom_ad_enabled == true ? <img width="100%" src={banners.bottom_ad} /> : ""}</a></div>
        </div>
        {is_admin || (props.rawUserContext.organization.data.id == room.owner) ? 
            <span><Modal
              title="Edit Booth"
              open={edit}
              submittable={false}
              closeText="Close"
              disallowClickOutside={true}
              close={() => {set_edit(false)}}
            >
              {error ? <div className="alert alert-danger">There was an error!</div>:''}
              <form>
                {is_admin ?
                  <div className="form-group">
                    <label htmlFor="company_name">Owning Company</label>
                    <select className="form-control" id="company_owner" aria-describedby="company_owner_help" onChange={() => handleChange(set_company_owner, event)}>
                        {buildOptions(props.orgs, company_owner)}
                    </select>
                    <small id="company_name_help" className="form-text text-muted">Select the company that owns this page</small>
                  </div>
                : ''}
                <div className="form-group">
                  <label htmlFor="company_name">Company Name</label>
                  <input type="text" className="form-control" id="company_name" aria-describedby="company_name_help" placeholder="CharTec" value={company_name} onChange={() => handleChange(set_company_name, event)}/>
                  <small id="company_name_help" className="form-text text-muted">Enter the Company Name</small>
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input type="text" className="form-control" id="email" aria-describedby="email_help" placeholder="support@chartec.net" value={email} onChange={() => handleChange(set_email, event)}/>
                  <small id="email_help" className="form-text text-muted">Enter email to recieve alerts when people visit when closed.</small>
                </div>
                <hr/>
                <div className="form-group fifty-percent fl-left">
                  <label htmlFor="logo">Logo (512x512)</label>
                  <input accept=".jpg,.jpeg,.gif,.png" type="file" className="form-control" id="logo" aria-describedby="logo_help" onChange={() => handleImageChange(set_logo, event)}></input>
                  <small id="logo_help" className="form-text text-muted">Upload Company Logo (512x512)</small>
                </div>
                <div className="form-group fifty-percent fl-right">
                  <label htmlFor="preview">Preview (Existing Image)</label>
                  <img className="fifty-px" src={props.logo} />
                </div>
                <hr className="clear-both" />
                <div className="form-group fifty-percent fl-left">
                  <label htmlFor="background">Background</label>
                  <input type="file" accept=".jpg,.jpeg,.gif,.png" className="form-control" id="background" aria-describedby="background_help" onChange={() => handleImageChange(set_background, event)}></input>
                  <small id="background_help" className="form-text text-muted">Upload Page Background</small>
                </div>
                <div className="form-group fifty-percent fl-right">
                  <label htmlFor="preview">Preview (Existing Image)</label>
                  <img className="fifty-px" src={props.background} />
                </div>
                <div className="checkbox clear-both">
                  <label><input type="checkbox" style={{marginTop : "-10px", width : '14px'}} onChange={() => handleCheckChange(set_background_enabled, background_enabled)} checked={background_enabled}/> Show Background?</label>
                </div>
                <hr className="clear-both"/>
                <div className="form-group fifty-percent fl-left">
                  <label htmlFor="left_ad">Left Banner</label>
                  <input type="file" accept=".jpg,.jpeg,.gif,.png" className="form-control" id="left_ad" aria-describedby="left_ad_help" onChange={() => handleImageChange(set_left_ad, event)}></input>
                  <small id="left_ad_help" className="form-text text-muted">Upload Left Banner</small>
                </div>
                <div className="form-group fifty-percent fl-right">
                  <label htmlFor="preview">Preview (Existing Image)</label>
                  <img className="fifty-px" src={banners.left_ad} />
                </div>
                <div className="form-group clear-both">
                  <label htmlFor="left_ad_link">Left Banner Link</label>
                  <input type="text" className="form-control" id="left_ad_link" aria-describedby="left_ad_link_help" placeholder="Enter URL" value={left_ad_link} onChange={() => handleChange(set_left_ad_link, event)}/>
                  <small id="left_ad_link_help" className="form-text text-muted">Enter the Left Banner Link Url</small>
                </div>
                <div className="checkbox">
                  <label><input type="checkbox" style={{marginTop : "-10px", width : '14px'}} onChange={() => handleCheckChange(set_left_ad_enabled, left_ad_enabled)} checked={left_ad_enabled}/> Show Left Banner?</label>
                </div>
                <hr/>
                <div className="form-group fifty-percent fl-left">
                  <label htmlFor="right_ad">Right Banner</label>
                  <input type="file" accept=".jpg,.jpeg,.gif,.png" className="form-control" id="right_ad" aria-describedby="right_ad_help" onChange={() => handleImageChange(set_right_ad, event)}></input>
                  <small id="right_ad_help" className="form-text text-muted">Upload Right Banner</small>
                </div>
                <div className="form-group fifty-percent fl-right">
                  <label htmlFor="preview">Preview (Existing Image)</label>
                  <img className="fifty-px" src={banners.right_ad} />
                </div>
                <div className="form-group clear-both">
                  <label htmlFor="right_ad_link">Right Banner Link</label>
                  <input type="text" className="form-control" id="right_ad_link" aria-describedby="right_ad_link_help" placeholder="Enter URL" value={right_ad_link} onChange={() => handleChange(set_right_ad_link, event)}/>
                  <small id="right_ad_link_help" className="form-text text-muted">Enter the Right Banner Link Url</small>
                </div>
                <div className="checkbox">
                  <label><input type="checkbox" style={{marginTop : "-10px", width : '14px'}} onChange={() => handleCheckChange(set_right_ad_enabled, right_ad_enabled)} checked={right_ad_enabled}/> Show Right Banner?</label>
                </div>
                <hr/>
                <div className="form-group fifty-percent fl-left">
                  <label htmlFor="top_ad">Top Banner</label>
                  <input type="file" accept=".jpg,.jpeg,.gif,.png" className="form-control" id="top_ad" aria-describedby="top_ad_help" onChange={() => handleImageChange(set_top_ad, event)}></input>
                  <small id="top_ad_help" className="form-text text-muted">Upload Top Banner</small>
                </div>
                <div className="form-group fifty-percent fl-right">
                  <label htmlFor="preview">Preview (Existing Image)</label>
                  <img className="fifty-px" src={banners.top_ad} />
                </div>
                <div className="form-group clear-both">
                  <label htmlFor="top_ad_link">Top Banner Link</label>
                  <input type="text" className="form-control" id="top_ad_link" aria-describedby="top_ad_link_help" placeholder="Enter URL" value={top_ad_link} onChange={() => handleChange(set_top_ad_link, event)}/>
                  <small id="top_ad_link_help" className="form-text text-muted">Enter the Top Banner Link Url</small>
                </div>
                <div className="checkbox">
                  <label><input type="checkbox" style={{marginTop : "-10px", width : '14px'}} onChange={() => handleCheckChange(set_top_ad_enabled, top_ad_enabled)} checked={top_ad_enabled}/> Show Top Banner?</label>
                </div>
                <hr/>
                <div className="form-group fifty-percent fl-left">
                  <label htmlFor="bottom_ad">Bottom Banner</label>
                  <input type="file" accept=".jpg,.jpeg,.gif,.png" className="form-control" id="bottom_ad" aria-describedby="bottom_ad_help" onChange={() => handleImageChange(set_bottom_ad, event)}></input>
                  <small id="bottom_ad_help" className="form-text text-muted">Upload Bottom Banner</small>
                </div>
                <div className="form-group fifty-percent fl-right">
                  <label htmlFor="preview">Preview (Existing Image)</label>
                  <img className="fifty-px" src={banners.bottom_ad} />
                </div>
                <div className="form-group clear-both">
                  <label htmlFor="bottom_ad_link">Bottom Banner Link</label>
                  <input type="text" className="form-control" id="bottom_ad_link" aria-describedby="bottom_ad_link_help" placeholder="Enter URL" value={bottom_ad_link} onChange={() => handleChange(set_bottom_ad_link, event)}/>
                  <small id="bottom_ad_link_help" className="form-text text-muted">Enter the Bottom Banner Link Url</small>
                </div>
                <div className="checkbox">
                  <label><input type="checkbox" style={{marginTop : "-10px", width : '14px'}} onChange={() => handleCheckChange(set_bottom_ad_enabled, bottom_ad_enabled)} checked={bottom_ad_enabled}/> Show Bottom Banner?</label>
                </div>
                <hr/>
                <div className="checkbox">
                  <label><input type="checkbox" style={{marginTop : "-10px", width : '14px'}} onChange={() => handleCheckChange(set_open, open)} checked={open}/> Is Open?</label>
                </div>
                <br/>

                <div className="btn btn-primary" onClick={() => {save(props, set_error, open, background, left_ad, right_ad, top_ad, bottom_ad, company_name, left_ad_link, right_ad_link, top_ad_link, bottom_ad_link, company_owner, logo, background_enabled, top_ad_enabled, bottom_ad_enabled, left_ad_enabled, right_ad_enabled, email)}}>Save</div>
              </form>
          </Modal>
          <Modal 
              title="View Chat History"
              open={log_open}
              submittable={false}
              closeText="Close"
              disallowClickOutside={true}
              close={() => {set_log_open(false)}}>
              <span>
                <div className="form-group">
                  <label htmlFor="select_day">Select Date For Historical Logs</label>
                  <input type="date" id="select_day" defaultValue={new Date().toISOString().slice(0, 10)}/>
                </div>
                <div className="btn btn-primary" onClick={() => get_historical(set_historical_chat, document.getElementById('select_day'), props.id, current_user_email)}>View Log</div>
                <div style={{marginLeft : "10px"}} className="btn btn-primary" onClick={() => export_historical(document.getElementById('select_day'), props.id)}>Export Log</div>
                <hr/>
                <div id="sponsor">
                  <div className="messaging">
                    <div className="inbox_msg">
                      <div className="mesgs">
                        <div className="msg_history chat-messages">
                          {historical_chat}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </span>
          </Modal>
          <Modal 
              title="View Booth Analytics"
              open={analytics_open}
              submittable={false}
              closeText="Close"
              disallowClickOutside={true}
              close={() => {set_analytics_open(false)}}>
              <span>
                <div className="form-group">
                  <label htmlFor="select_day">Select Date For Booth Analytics</label>
                  <input type="date" id="select_day_analytics" defaultValue={new Date().toISOString().slice(0, 10)}/>
                </div>
                <div className="btn btn-primary" onClick={() => BuildAnalytics(props, document.getElementById('select_day_analytics'))}>View Analytics</div>
              </span>
          </Modal>
          </span>
        : ''}
      </div>
    )
  } else {
    return (
      <span>
        {is_admin ? <div className="row" style={{paddingTop : "15px"}}><div style={{marginLeft : "50px"}} className="btn btn-primary" onClick={()=>{createRoom(props.id)}}>Create Room ({props.id})</div></div>:''}
        <div className="row" style={{paddingTop : "15px"}}>
          <div className="col-xs-6 col-md-offset-1">
            <div className="alert alert-info">
              <strong>Info!</strong> Looks like there isn't a room available. Please try again later.
            </div>
          </div>
        </div>
      </span>
    )
  }
}

async function export_historical(e,room){
  let url = "https://matomo.chartec.net/sponsor_reports/chat_csv.php?day="+e.value+"&room="+room;
  const res = await jfetch.get(url);
  if(res){
    if(!res.error){
      var win = window.open('https://matomo.chartec.net/sponsor_reports/reports/'+res.file, '_blank');
      if (win) {
        //do nothing
      } else {
          //Browser has blocked it
          toast.error('Please allow popups for this website');
      }
    } else {
      toast.error(res.error);
    }
  }
}

async function get_historical(set_historical_chat, e, room, current_user_email){
  var object = '{"day": "'+e.value+'", "admin": 1, "room": "'+room+'"}';
  var encoded = encodeURIComponent(btoa(object));
  const res = await jfetch.get('https://matomo.chartec.net/sponsor_reports/chat_history.php?object='+encoded);
    if(res){
      if(!res.error){
        var return_html = [];
        Object.entries(res).forEach(entry => {
          let key = entry[0];
          let value : any = entry[1];
          if(current_user_email == value.email){
            return_html.push(<div key={key} className="outgoing_msg">
              <div className="outgoing_msg_img"> <img className="profile-pic" src={value.image} /> </div>
                <div className="sent_msg">
                  <div className="sent_withd_msg">
                    <b style={{fontSize:"12px"}}>{value.name} ({value.email})<br/>{value.title} at {value.company}</b>
                    <p>{value.message}</p>
                    <span className="time_date">{value.time}</span>
                  </div>
                </div>
              </div>);
          } else {
            return_html.push(<div key={key} className="incoming_msg">
              <div className="incoming_msg_img"> <img className="profile-pic" src={value.image} /> </div>
                <div className="received_msg">
                  <div className="received_withd_msg">
                    <b style={{fontSize:"12px"}}>{value.name} ({value.email})<br/>{value.title} at {value.company}</b>
                    <p>{value.message}</p>
                    <span className="time_date">{value.time}</span>
                  </div>
                </div>
              </div>);
            }
          }
        );
        set_historical_chat(return_html);
      } else {
        set_historical_chat(<h4>No Chat Records</h4>);
      }
    }
}

async function open_info(link){
  window.open(link, "_blank", "toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=800,height=850");
}

async function toggle_booth(props, open) {
  var open_opposite:any = !open;
  const formData = new FormData();
  formData.append("open", open_opposite);
  const res = await jfetch.patch('/sponsor/rooms/'+props.id, formData);
    if(res){
      if(res.status == "success"){
        location.reload();
      } else {
        //nothing
      }
    }
}

async function createRoom(id){
  const res = await jfetch.post('/sponsor/rooms',{slug:id});
    if (res){
      location.reload();
    }
}

function buildOptions (orgs, company_owner){
  var arr = [];

  orgs.forEach(function (item, index) {
    arr.push(<option key={item[0]} value={item[0]} selected = {company_owner == item[0] ? true : false}>{item[1]}</option>);
  });

  return arr; 
}

function handleChange(hook, event){
  hook(event.target.value);
}

function handleCheckChange(hook, value){
  hook(!value);
}

function handleImageChange(hook, e) {
  if (e.target.files[0]) hook(e.target.files[0]);
}

async function save(props, set_error, open, background, left_ad, right_ad, top_ad, bottom_ad, company_name, left_ad_link, right_ad_link, top_ad_link, bottom_ad_link, company_owner, logo, background_enabled, top_ad_enabled, bottom_ad_enabled, left_ad_enabled, right_ad_enabled, email){
    const formData = new FormData();
    if(background){
      formData.append("background", background);
    }
    if(left_ad){
      formData.append("left_ad", left_ad);
    }
    if(right_ad){
      formData.append("right_ad", right_ad);
    }
    if(top_ad){
      formData.append("top_ad", top_ad);
    }
    if(bottom_ad){
      formData.append("bottom_ad", bottom_ad);
    }
    if(logo){
      formData.append("logo", logo);
    }
    formData.append("email", email);
    formData.append("open", open);
    formData.append("name", company_name);
    formData.append("owner", company_owner);
    formData.append("background_enabled", background_enabled);
    formData.append("top_ad_enabled", top_ad_enabled);
    formData.append("bottom_ad_enabled", bottom_ad_enabled);
    formData.append("left_ad_enabled", left_ad_enabled);
    formData.append("right_ad_enabled", right_ad_enabled);
    //(background_link ? formData.append("background_link", background_link) : '');
    (left_ad_link ? formData.append("left_ad_link", left_ad_link) : '');
    (right_ad_link ? formData.append("right_ad_link", right_ad_link) : '');
    (top_ad_link ? formData.append("top_ad_link", top_ad_link) : '');
    (bottom_ad_link ? formData.append("bottom_ad_link", bottom_ad_link) : '');
    
    
    // configure your fetch url appropriately
    const res = await jfetch.patch('/sponsor/rooms/'+props.id, formData);
    if(res){
      if(res.status == "success"){
        location.reload();
      } else {
        set_error(true);
      }
    }
}

export default SponsorRoom;


// WEBPACK FOOTER //
// ./app/javascript/components/pages/SponsorRoom.tsx